import React, { useRef, useState } from 'react';
import './contact.css';
import LinkedInIcon from '../../assets/LI-In-Bug.png';
import GitHubIcon from '../../assets/github-mark-white.png';
import emailjs from '@emailjs/browser';
import ReCAPTCHA from 'react-google-recaptcha';

const Contact = () => {
  const form = useRef();
  const recaptchaRef = useRef();
  const [captchaToken, setCaptchaToken] = useState(null);

  const sendEmail = (e) => {
    e.preventDefault();
    if (!captchaToken) {
      alert('Please complete the reCAPTCHA verification');
      return;
    }
    const params = {
      your_name: e.target.your_name.value,
      your_email: e.target.your_email.value,
      message: e.target.message.value,
      'g-recaptcha-response': captchaToken,
    };
    emailjs.send('service_bdi2tle', 'template_s4c98bh', params, 'IJE41ciYPQdchAgPv')
      .then((result) => {
        console.log(result.text);
        e.target.reset();
        recaptchaRef.current.reset();
        setCaptchaToken(null);
        alert("Message sent successfully!");
      }, (error) => {
        console.log(error.text);
        alert("Failed to send message. Please try again.");
      });
  };

  return (
    <section id="contactPage">
      <div id="contact">
        <span className="contactLabel">GET IN TOUCH</span>
        <h1 className='contactPageTitle'>Let's Work Together</h1>
        <p className='contactDesc'>
          Open to data engineering roles, freelance pipeline work, and interesting collaborations.
          Fill out the form below or connect on LinkedIn.
        </p>

        <form className='contactForm' ref={form} onSubmit={sendEmail}>
          <div className="formRow">
            <div className="formField">
              <label htmlFor="your_name">Name</label>
              <input id="your_name" type="text" placeholder='Your Name' className='name' name='your_name' required/>
            </div>
            <div className="formField">
              <label htmlFor="your_email">Email</label>
              <input id="your_email" type="email" placeholder='your@email.com' className='email' name='your_email' required/>
            </div>
          </div>
          <div className="formField">
            <label htmlFor="message">Message</label>
            <textarea id="message" name="message" rows="5" placeholder="Tell me about the opportunity or project..." className='msg' required></textarea>
          </div>

          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <ReCAPTCHA
              ref={recaptchaRef}
              sitekey="6LfxCQQsAAAAAIqI7ZQjsJevVuteOR2RlxYm9MH2"
              onChange={(val) => setCaptchaToken(val)}
              theme="dark"
            />
          </div>

          <button type='submit' className='submitBtn'>Send Message</button>
        </form>

        <div className="links">
          <a href="https://linkedin.com/in/avikal-singh-079ab8184" target="_blank" rel="noreferrer" className="link">
            <img src={LinkedInIcon} alt="LinkedIn" className='linkImg'/>
            LinkedIn
          </a>
          <a href="https://github.com/avikalsingh" target="_blank" rel="noreferrer" className="link">
            <img src={GitHubIcon} alt="GitHub" className='linkImg'/>
            GitHub
          </a>
        </div>
      </div>
    </section>
  );
};

export default Contact;
